// extracted by mini-css-extract-plugin
module.exports = {"select":"UseCase_style_select__1uUyF"};